<template>
  <section class="quick-quote-info">
    <div class="table">
      <div class="tr th">
        <span>Item</span>
        <span>Information</span>
      </div>
      <template v-if="quoteForm.class_id === 14">
        <div class="tr">
          <span>Motor Type</span>
          <span>{{ getOptionName('classOptions', quoteForm.class_id) }}</span>
        </div>
        <div class="tr">
          <span>Car Use</span>
          <span>{{ getOptionName('usageOptions', quoteForm.usage_ind) }}</span>
        </div>
        <div class="tr">
          <span>Make</span>
          <span>{{ getAllOptionName('brand', quoteForm.brand_id) }}</span>
        </div>
        <div class="tr">
          <span>Body Type</span>
          <span>{{ getAllOptionName('typ_of_bdy', quoteForm.typ_of_bdy_id) }}</span>
        </div>
      </template>
      <template v-else>
        <div class="tr">
          <span>Car Type</span>
          <span>{{ getOptionName('classOptions', quoteForm.class_id) }}</span>
        </div>
        <template v-if="quoteForm.class_id === 11">
          <div class="tr">
            <span>Make</span>
            <span>{{ getAllOptionName11('brand', quoteForm.brand_id) }}</span>
          </div>
          <div class="tr">
            <span>Year of Manufacture</span>
            <span>{{ getAllOptionName11('rgtn_yr', quoteForm.rgtn_yr) }}</span>
          </div>
        </template>
        <template v-else>
          <div class="tr">
            <span>Make</span>
            <span>{{ getAllOptionName12('brand', quoteForm.brand_id) }}</span>
          </div>
          <div class="tr">
            <span>Year of Manufacture</span>
            <span>{{ getAllOptionName12('rgtn_yr', quoteForm.rgtn_yr) }}</span>
          </div>
        </template>
        <div
          v-if="quoteForm.class_id == 11||quoteForm.class_id==14"
          class="tr">
          <span>Number of Driver(s)</span>
          <span>{{ getOptionName('numberFourOptions', quoteForm.no_of_nm_drvr) }}</span>
        </div>
      </template>
    </div>
    <div class="table">
      <div class="tr th">
        <span>Item</span>
        <span>Information</span>
      </div>
      <template v-if="quoteForm.class_id === 14">
        <!-- <div class="tr">
            <span>Permitted Gross Vehicle Weight</span>
            <span>10 Tonnes</span>
          </div> -->
        <div class="tr">
          <span>Year of Manufacture</span>
          <span>{{ getAllOptionName('rgtn_yr', quoteForm.rgtn_yr) }}</span>
        </div>
        <div class="tr">
          <span>NCD</span>
          <span>{{ getAllOptionName('ncd', quoteForm.ncd_pct) }}</span>
        </div>
      </template>
      <template v-else>
        <template v-if="quoteForm.class_id === 11">
          <div class="tr">
            <span>NCD</span>
            <span>{{ getAllOptionName11('ncd', quoteForm.ncd_pct) }}</span>
          </div>
          <div class="tr">
            <span>Car Model</span>
            <span>{{ getOptionName('carModelOptions', quoteForm.model_id) }}</span>
          </div>
          <div class="tr">
            <span>Body Type</span>
            <span>{{ getAllOptionName11('typ_of_bdy', quoteForm.typ_of_bdy_id) }}</span>
          </div>
        </template>
        <template v-else>
          <div class="tr">
            <span>NCD</span>
            <span>{{ getAllOptionName12('ncd', quoteForm.ncd_pct) }}</span>
          </div>
          <!-- <div class="tr">
            <span>Body Type</span>
            <span>{{ getAllOptionName12('typ_of_bdy', quoteForm.typ_of_bdy_id) }}</span>
          </div> -->
          <!-- <div class="tr">
            <span>Vehicle Type</span>
            <span>{{ getAllOptionName12('tonnage', quoteForm.tonnage) }}</span>
          </div> -->
        </template>

        <!-- <div
          v-if="quoteForm.class_id === 12"
          class="tr">
          <span>Permitted Gross Combined Weight</span>
          <span>{{ quoteForm.tonnage }} tonnes</span>
        </div> -->
        <div
          v-if="quoteForm.class_id != 12&&!quoteForm.is_electric_car"
          class="tr">
          <span>Cylinder Capacity (Input "0" for EV)</span>
          <span>{{ quoteForm.engn_cpcty||0 }} cc</span>
        </div>
      </template>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapState} from 'vuex'
export default {
  name: 'MotorQuickQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    quoteForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapState('quote', [ 'carModelOptions']),
  },
}
</script>
<style lang="scss" scoped>
.quick-quote-info {
    display: flex;
    justify-content: space-between;
    .table {
        width: calc(50% - 10px);
    }
}
</style>
